import { IglobalThis } from '@shared-components/types';

// Only fire the pixel and CAPI event for Social Media Cookies (MRA) categoryID (9)
export function sendFacebookEvent(eventName: string) {
	const customGlobalThis: IglobalThis = globalThis;
	const doNotTrackStates = ['CO', 'VA', 'CA', 'LA', 'MO', 'SD', 'ME', 'NY'];
	if (
		(!!customGlobalThis?.OptanonActiveGroups &&
			(customGlobalThis?.OptanonActiveGroups as string)?.indexOf(',9,') >= 0) ||
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
		(navigator?.doNotTrack !== '1' &&
			// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
			!doNotTrackStates.includes(customGlobalThis?.Optanon?.getGeolocationData()?.state))
	) {
		if (customGlobalThis.fbq !== undefined) {
			const facebookEventId = createFacebookEventId();
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			customGlobalThis.fbq('track', eventName, { fillerInfo: 'info' }, { eventID: facebookEventId });
		}
	}
}

function createFacebookEventId() {
	return crypto.randomUUID();
}
